import { useState, useCallback } from "react";

type RefetchFn = () => Promise<unknown>;

export function useProductRefresh(refetch: RefetchFn) {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    setIsRefreshing(true);
    await refetch();
    setTimeout(() => setIsRefreshing(false), 500);
  }, [refetch]);

  return { handleRefresh, isRefreshing };
}
